((app, ng) => {

    app.controller("importContactsController", importContactsController);

    function importContactsController(advisorApi, clientApi, figToaster, $mdDialog, $q, $state) {
        const $ctrl = this;

        ng.extend($ctrl,
            {
                ui: {
                    currentIndex: 0,
                    loading: false
                },
                importErrors: []
            });

        $ctrl.uploadList = (file) => {
            //$ctrl.ui.currentIndex++;
            $ctrl.fileError = false;
            var message = "", toastClass = "";
            if (file) {
                $ctrl.ui.uploading = true;
                const payload = new FormData();
                payload.append("contactsImport", file);

                clientApi.importContacts(payload)
                    .then(function (response) {
                        //show success page when contacts imported without error
                        $ctrl.ui.currentIndex = 2;
                        //message = !!response ? response + " contacts added successfully!" : "Contacts added successfully!";
                        //toastClass = "is-success";
                        $ctrl.importCount = response;
                        return;
                    })
                    .catch(function (error) {
                        $ctrl.ui.currentIndex = 1;
                        if (error.status === 422) {
                            $ctrl.importErrors = error.data;
                        } else {
                            $ctrl.fileError = true;
                            console.log(error.data);
                        }
                    })
                    .finally(function () {
                        $ctrl.ui.uploading = false;
                    });
            } else {
                message = "Error: No valid file attached";
                toastClass = "is-error";
                return figToaster.showSimple(message, "top", toastClass);
            }
        };

        $ctrl.copyElement = (element) => {
            /* Get the text field */
            const copyText = document.getElementById(element);

            /* Select the text field */
            copyText.select();
            copyText.setSelectionRange(0, 99999); /*For mobile devices*/

            /* Copy the text inside the text field */
            document.execCommand("copy");
        };

        $ctrl.close = () => {
            $mdDialog.hide();
        };

        $ctrl.$onInit = () => {
            $ctrl.ui.loading = true;
            $ctrl.contactsImport = {};
            const promises = [
                clientApi.getClientTypes(),
                advisorApi.getCurrentUserParentAdvisors()
            ];

            $q.all(promises)
                .then((responses) => {
                    $ctrl.clientTypes = responses[0];
                    $ctrl.advisors = responses[1];

                    // if the current user is an advisor make them first on the list
                    if (!!$ctrl.currentUser.AdvisorId && $ctrl.currentUser.AdvisorId !== "00000000-0000-0000-0000-000000000000") {
                        $ctrl.PrimaryAdvisorId = $ctrl.currentUser.AdvisorId;

                        $ctrl.primaryAdvisor = {
                            Id: $ctrl.currentUser.AdvisorId,
                            Person: {
                                FirstName: $ctrl.currentUser.FirstName,
                                LastName: $ctrl.currentUser.LastName
                            }
                        };

                        // set current user to first advisor in advisor's list
                        $ctrl.advisors.unshift($ctrl.primaryAdvisor);
                    }
                })
                .finally(() => { $ctrl.ui.loading = false; });
        };

    }

})(window.app, window.angular);